/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeliverableList_stateTypes$ref: FragmentReference;
declare export opaque type DeliverableList_stateTypes$fragmentType: DeliverableList_stateTypes$ref;
export type DeliverableList_stateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: DeliverableList_stateTypes$ref,
|};
export type DeliverableList_stateTypes$data = DeliverableList_stateTypes;
export type DeliverableList_stateTypes$key = {
  +$data?: DeliverableList_stateTypes$data,
  +$fragmentRefs: DeliverableList_stateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DeliverableList_stateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '734a1c4d11891fb2a25c7ce8702bec8f';
module.exports = node;
